import axios from "axios";

import { store } from "../_app/store";
import { resetUser, updateUserIntialState } from "../_features";

// Session timeout constants (in milliseconds)
const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes
const LOGOUT_MESSAGE_THRESHOLD = 60 * 60 * 1000; // 1 hour

// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    const timeElapsedSinceLastActivity =
      Date.now() - store.getState().user.lastActivityTime;

    console.log("timeElpasedSinceLastActivity", timeElapsedSinceLastActivity);
    if (
      timeElapsedSinceLastActivity > SESSION_TIMEOUT &&
      store.getState().user.lastLoggedInTime !== null
    ) {

      if(timeElapsedSinceLastActivity < LOGOUT_MESSAGE_THRESHOLD){
      localStorage.setItem('showLogoutMessage', 'true');
      }

      store.dispatch(resetUser());
    }
    
    if (
      store.getState().user.permission === "read" &&
      (config.method === "post" ||
        config.method === "patch" ||
        config.method === "delete")
    ) {
      throw new axios.Cancel("You are not allowed this operation");
    }
    if (store.getState().user.access) {
      config.headers["Authorization"] = `Bearer ${
        store.getState().user.access
      }`;
    }
    store.dispatch(
              updateUserIntialState({
                ...store.getState().user,
                lastActivityTime: Date.now(),
              })
            );
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    return response;
  },

  async function (error) {
    if (error.response.status === 401) {
      store.dispatch(updateUserIntialState({ isSessionActive: false }));
      // if (store.getState().user?.access) {
      // 	try {
      // 		const tokenResponse = await AuthService._refreshToken();
      // 		const payloadData = {
      // 			access: tokenResponse.data.access,
      // 			refresh: tokenResponse.data.refresh,
      // 		};
      // 		store.dispatch(updateUserIntialState(payloadData));
      // 	} catch (error) {
      // 		window.location.href = "/";
      // 	}
      // } else {
      // 	window.location.href = "/";
      // }
    }

    return Promise.reject(error);
  }
);

export default axios;
